"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconMeta = void 0;
var _designTokens = require("@smartsheet/design-tokens");
// TODO apply these

const allowedColors = {
  ..._designTokens.ursaColors,
  transparent: "transparent"
};
const iconMeta = {
  ActivityIcon: {
    description: "History of activities on a sheet/report.",
    sizes: {
      "20": "./svg/activity-20px.svg",
      "24": "./svg/activity-24px.svg"
    },
    aliases: ["history"]
  },
  AddAttachmentIcon: {
    description: "",
    sizes: {
      "16": "./svg/add-attachment-16px.svg"
    },
    aliases: ["file", "paperclip"],
    tags: []
  },
  AddCommentIcon: {
    description: "",
    sizes: {
      "16": "./svg/add-comment-16px.svg",
      "20": "./svg/add-comment-20px.svg",
      "24": "./svg/add-comment-24px.svg"
    },
    aliases: ["chat", "conversation"],
    tags: []
  },
  AddEmojiIcon: {
    description: "",
    sizes: {
      "20": "./svg/add-emoji-20px.svg",
      "24": "./svg/add-emoji-24px.svg"
    },
    aliases: ["smiley", "emoticon"],
    tags: []
  },
  AddSubItemIcon: {
    description: "",
    sizes: {
      "20": "./svg/add-sub-item-20px.svg",
      "24": "./svg/add-sub-item-24px.svg"
    },
    aliases: ["indent", "hierarchy"],
    tags: []
  },
  AlertErrorFilledIcon: {
    description: "",
    sizes: {
      "20": "./svg/alert-error-filled-20px.svg",
      "24": "./svg/alert-error-filled-24px.svg"
    },
    aliases: ["warning", "exclamation", "caution"],
    tags: ["alert", "banner"]
  },
  AlphaNumericIcon: {
    description: "",
    sizes: {
      "20": "./svg/alpha-numeric-20px.svg",
      "24": "./svg/alpha-numeric-24px.svg"
    },
    aliases: ["A1", "text", "number"],
    tags: []
  },
  AnnotationArrowIcon: {
    description: "",
    sizes: {
      "20": "./svg/annotation-arrow-20px.svg",
      "24": "./svg/annotation-arrow-24px.svg"
    },
    aliases: ["comment", "note"],
    tags: []
  },
  ArrowSmallDownIcon: {
    description: "Dropdown arrow",
    sizes: {
      "20": "./svg/arrow-small-down-20px.svg",
      "24": "./svg/arrow-small-down-24px.svg",
      "16": "./svg/arrow-small-down-16px.svg"
    },
    aliases: ["arrow", "down"]
  },
  AttachIcon: {
    description: "Attach files, links, etc.",
    sizes: {
      "20": "./svg/attach-20px.svg",
      "24": "./svg/attach-24px.svg"
    },
    aliases: ["file", "paperclip"]
  },
  AttachFileIcon: {
    description: "Attach files",
    sizes: {
      "16": "./svg/attach-file-16px.svg",
      "20": "./svg/attach-file-20px.svg",
      "24": "./svg/attach-file-24px.svg"
    },
    aliases: ["file", "paperclip"],
    colorSlots: {
      ["transparent"]: {
        propName: "backgroundColor",
        tsDoc: "The fill color for the background.",
        defaultColor: "transparent"
      }
    }
  },
  BackIcon: {
    description: "Navigate back",
    sizes: {
      "20": "./svg/back-20px.svg",
      "24": "./svg/back-24px.svg"
    },
    aliases: ["left", "arrow"]
  },
  BackgroundColorIcon: {
    description: "Style background color of selected element.",
    sizes: {
      "20": "./svg/background-color-20px.svg",
      "24": "./svg/background-color-24px.svg"
    },
    aliases: ["fill"],
    tags: []
  },
  BackgroundColorWithSelectionIcon: {
    description: "Style background color of selected element with selection strip.",
    sizes: {
      "20": "./svg/background-color-with-selection-20px.svg",
      "24": "./svg/background-color-with-selection-24px.svg"
    },
    aliases: ["fill"],
    tags: [],
    colorSlots: {
      [_designTokens.ursaColors.blue500]: {
        tsDoc: "The color of the highlight bar on the bottom.",
        propName: "selectedColor"
      }
    }
  },
  BankIcon: {
    description: "",
    sizes: {
      "20": "./svg/bank-20px.svg",
      "24": "./svg/bank-24px.svg"
    },
    aliases: ["building", "financial"],
    tags: []
  },
  BaselineIcon: {
    description: "",
    sizes: {
      "20": "./svg/baseline-20px.svg",
      "24": "./svg/baseline-24px.svg"
    },
    aliases: [],
    tags: []
  },
  BellAlertIcon: {
    description: "",
    sizes: {
      "20": "./svg/bell-alert-20px.svg",
      "24": "./svg/bell-alert-24px.svg"
    },
    aliases: ["notification"],
    tags: []
  },
  BellAlertOffIcon: {
    description: "",
    sizes: {
      "20": "./svg/bell-alert-off-20px.svg",
      "24": "./svg/bell-alert-off-24px.svg"
    },
    aliases: ["notification"],
    tags: []
  },
  BidirectionalArrowIcon: {
    description: "",
    sizes: {
      "20": "./svg/bidirectional-arrow-20px.svg",
      "24": "./svg/bidirectional-arrow-24px.svg"
    },
    aliases: ["arrow", "left", "right"],
    tags: []
  },
  BoardIcon: {
    description: "Board view",
    sizes: {
      "20": "./svg/board-20px.svg",
      "24": "./svg/board-24px.svg"
    },
    aliases: [],
    tags: []
  },
  BoldIcon: {
    description: "Increase font weight",
    sizes: {
      "20": "./svg/bold-20px.svg",
      "24": "./svg/bold-24px.svg"
    },
    aliases: [],
    tags: []
  },
  BrandfolderIcon: {
    description: "",
    sizes: {
      "20": "./svg/brandfolder-20px.svg",
      "24": "./svg/brandfolder-24px.svg"
    },
    aliases: [],
    tags: []
  },
  BullseyeIcon: {
    description: "",
    sizes: {
      "20": "./svg/bullseye-20px.svg",
      "24": "./svg/bullseye-24px.svg"
    },
    aliases: ["target"],
    tags: []
  },
  CalendarIcon: {
    description: "Calendar",
    sizes: {
      "16": "./svg/calendar-16px.svg",
      "20": "./svg/calendar-20px.svg",
      "24": "./svg/calendar-24px.svg"
    },
    aliases: ["date", "day", "month", "year"],
    tags: []
  },
  CalendarWithCheckmarkIcon: {
    description: "",
    sizes: {
      "20": "./svg/calendar-with-checkmark-20px.svg",
      "24": "./svg/calendar-with-checkmark-24px.svg"
    },
    aliases: ["date", "day", "month", "year", "due"],
    tags: []
  },
  CalendarWithPencilIcon: {
    description: "",
    sizes: {
      "20": "./svg/calendar-with-pencil-20px.svg",
      "24": "./svg/calendar-with-pencil-24px.svg"
    },
    aliases: ["date", "day", "month", "year", "edit", "modify"],
    tags: []
  },
  CardIcon: {
    description: "Card view",
    sizes: {
      "20": "./svg/card-20px.svg",
      "24": "./svg/card-24px.svg"
    },
    aliases: [],
    tags: []
  },
  CardCompactIcon: {
    description: "",
    sizes: {
      "20": "./svg/card-compact-20px.svg",
      "24": "./svg/card-compact-24px.svg"
    },
    aliases: ["collapse"],
    tags: []
  },
  CardCozyIcon: {
    description: "",
    sizes: {
      "20": "./svg/card-cozy-20px.svg",
      "24": "./svg/card-cozy-24px.svg"
    },
    aliases: ["expand", "comfortable"],
    tags: []
  },
  CardGridIcon: {
    description: "",
    sizes: {
      "20": "./svg/card-grid-20px.svg",
      "24": "./svg/card-grid-24px.svg"
    },
    aliases: ["squares"],
    tags: [],
    colorSlots: {
      ["transparent"]: {
        propName: "backgroundColor",
        tsDoc: "The fill color for the background.",
        defaultColor: "transparent"
      }
    }
  },
  CellLinkIcon: {
    description: "",
    sizes: {
      "20": "./svg/cell-link-20px.svg",
      "24": "./svg/cell-link-24px.svg"
    },
    aliases: ["link"],
    tags: []
  },
  ChartIcon: {
    description: "",
    sizes: {
      "20": "./svg/chart-20px.svg",
      "24": "./svg/chart-24px.svg"
    },
    aliases: ["graph", "data"],
    tags: []
  },
  CheckboxCheckedIcon: {
    description: "",
    sizes: {
      "20": "./svg/checkbox-checked-20px.svg",
      "24": "./svg/checkbox-checked-24px.svg"
    },
    aliases: ["checked", "filled"],
    tags: []
  },
  CheckboxUncheckedIcon: {
    description: "",
    sizes: {
      "20": "./svg/checkbox-unchecked-20px.svg",
      "24": "./svg/checkbox-unchecked-24px.svg"
    },
    aliases: ["unchecked", "empty"],
    tags: []
  },
  CheckboxValueBlankIcon: {
    description: "",
    sizes: {
      "20": "./svg/checkbox-value-blank-20px.svg",
      "24": "./svg/checkbox-value-blank-24px.svg"
    },
    aliases: ["indeterminate", "unfilled"],
    tags: []
  },
  CheckboxValueNotBlankIcon: {
    description: "",
    sizes: {
      "20": "./svg/checkbox-value-not-blank-20px.svg",
      "24": "./svg/checkbox-value-not-blank-24px.svg"
    },
    aliases: ["indeterminate", "filled"],
    tags: []
  },
  CheckInCircleIcon: {
    description: "",
    sizes: {
      "16": "./svg/check-in-circle-16px.svg",
      "20": "./svg/check-in-circle-20px.svg",
      "24": "./svg/check-in-circle-24px.svg"
    },
    aliases: ["checkmark", "tick", "success"],
    tags: []
  },
  ChecklistIcon: {
    description: "",
    sizes: {
      "20": "./svg/checklist-20px.svg",
      "24": "./svg/checklist-24px.svg"
    },
    aliases: ["list", "todo", "dropdown"],
    tags: []
  },
  CheckmarkIcon: {
    description: "",
    sizes: {
      "20": "./svg/checkmark-20px.svg",
      "24": "./svg/checkmark-24px.svg"
    },
    aliases: ["check", "success"],
    tags: []
  },
  CheckOnDotIcon: {
    description: "",
    sizes: {
      "16": "./svg/check-on-dot-16px.svg",
      "20": "./svg/check-on-dot-20px.svg",
      "24": "./svg/check-on-dot-24px.svg"
    },
    aliases: ["confirmed", "success", "approved"],
    tags: [],
    defaultColor: "ursaColors.mint400"
  },
  ChevronDownIcon: {
    description: "",
    sizes: {
      "16": "./svg/chevron-down-16px.svg",
      "20": "./svg/chevron-down-20px.svg",
      "24": "./svg/chevron-down-24px.svg"
    },
    aliases: ["caret", "chevron", "down", "expand"],
    tags: []
  },
  ChevronLeftIcon: {
    description: "",
    sizes: {
      "16": "./svg/chevron-left-16px.svg",
      "20": "./svg/chevron-left-20px.svg",
      "24": "./svg/chevron-left-24px.svg"
    },
    aliases: ["caret", "chevron", "left"],
    tags: []
  },
  ChevronLeftLineIcon: {
    description: "",
    sizes: {
      "20": "./svg/chevron-left-line-20px.svg",
      "24": "./svg/chevron-left-line-24px.svg"
    },
    aliases: ["caret", "chevron", "left", "back"],
    tags: []
  },
  ChevronRightIcon: {
    description: "",
    sizes: {
      "16": "./svg/chevron-right-16px.svg",
      "20": "./svg/chevron-right-20px.svg",
      "24": "./svg/chevron-right-24px.svg"
    },
    aliases: ["caret", "chevron", "collapse", "right"],
    tags: []
  },
  ChevronRightLineIcon: {
    description: "",
    sizes: {
      "20": "./svg/chevron-right-line-20px.svg",
      "24": "./svg/chevron-right-line-24px.svg"
    },
    aliases: ["caret", "chevron", "right", "forward"],
    tags: []
  },
  ChevronUpIcon: {
    description: "",
    sizes: {
      "16": "./svg/chevron-up-16px.svg",
      "20": "./svg/chevron-up-20px.svg",
      "24": "./svg/chevron-up-24px.svg"
    },
    aliases: ["caret", "chevron", "up"],
    tags: []
  },
  ClockIcon: {
    description: "",
    sizes: {
      "20": "./svg/clock-20px.svg",
      "24": "./svg/clock-24px.svg"
    },
    aliases: ["recent", "time"],
    tags: []
  },
  ClosedCaptionFilledIcon: {
    description: "",
    sizes: {
      "20": "./svg/closed-caption-filled-20px.svg",
      "24": "./svg/closed-caption-filled-24px.svg"
    },
    aliases: ["subtitles", "captions"],
    tags: []
  },
  ClosedCaptionUnfilledIcon: {
    description: "",
    sizes: {
      "20": "./svg/closed-caption-unfilled-20px.svg",
      "24": "./svg/closed-caption-unfilled-24px.svg"
    },
    aliases: ["subtitles", "captions"],
    tags: []
  },
  CloseIcon: {
    description: "Close or dismiss an element/panel/modal/banner that is open",
    sizes: {
      "16": "./svg/close-16px.svg",
      "20": "./svg/close-20px.svg",
      "24": "./svg/close-24px.svg"
    },
    aliases: ["clear", "remove"],
    tags: []
  },
  CloseFillIcon: {
    description: "Close or dismiss an element/panel/modal/banner that is open",
    sizes: {
      "16": "./svg/close-fill-16px.svg",
      "20": "./svg/close-fill-20px.svg",
      "24": "./svg/close-fill-24px.svg"
    },
    aliases: ["clear", "remove", "exit"],
    tags: []
  },
  CloudIcon: {
    description: "",
    sizes: {
      "20": "./svg/cloud-20px.svg",
      "24": "./svg/cloud-24px.svg"
    },
    aliases: ["weather"]
  },
  CodeFileIcon: {
    description: "",
    sizes: {
      "20": "./svg/code-file-20px.svg",
      "24": "./svg/code-file-24px.svg"
    },
    aliases: [],
    tags: []
  },
  CollaborateIcon: {
    description: "",
    sizes: {
      "20": "./svg/collaborate-20px.svg",
      "24": "./svg/collaborate-24px.svg"
    },
    aliases: ["people", "team", "users"],
    tags: []
  },
  ColumnTypeIcon: {
    description: "",
    sizes: {
      "20": "./svg/column-type-20px.svg",
      "24": "./svg/column-type-24px.svg"
    },
    aliases: [],
    tags: []
  },
  CompactIcon: {
    description: "Condensed view of elements on a page",
    sizes: {
      "20": "./svg/compact-20px.svg",
      "24": "./svg/compact-24px.svg"
    },
    aliases: ["dense"],
    tags: []
  },
  ConditionalFormattingIcon: {
    description: "",
    sizes: {
      "20": "./svg/conditional-formatting-20px.svg",
      "24": "./svg/conditional-formatting-24px.svg"
    },
    aliases: ["format"],
    tags: [],
    colorSlots: {
      // hardcoded instead of pulling from ursaColors in anticipation of the color palette changing
      "#A2ABCD": {
        tsDoc: "The color of the two filled inner blocks.",
        propName: "innerFillColor",
        defaultColor: "#A2ABCD"
      }
    }
  },
  ConnectorsIcon: {
    description: "",
    sizes: {
      "20": "./svg/connectors-20px.svg",
      "24": "./svg/connectors-24px.svg"
    },
    aliases: ["mutual", "reciprocal"],
    tags: []
  },
  ContentLibraryIcon: {
    description: "",
    sizes: {
      "20": "./svg/content-library-20px.svg",
      "24": "./svg/content-library-24px.svg"
    },
    aliases: ["folder", "images", "pictures"],
    tags: []
  },
  ContentLibraryColorIcon: {
    description: "",
    sizes: {
      "20": "./svg/content-library-color-20px.svg",
      "24": "./svg/content-library-color-24px.svg"
    },
    aliases: ["folder", "images", "pictures"],
    tags: []
  },
  ContractIcon: {
    description: "",
    sizes: {
      "20": "./svg/contract-20px.svg",
      "24": "./svg/contract-24px.svg"
    },
    aliases: [],
    tags: []
  },
  ContractVerticalIcon: {
    description: "",
    sizes: {
      "20": "./svg/contract-vertical-20px.svg",
      "24": "./svg/contract-vertical-24px.svg"
    },
    aliases: ["collapse", "shrink", "minimize"],
    tags: []
  },
  CollapseDownIcon: {
    description: "",
    sizes: {
      "20": "./svg/collapse-down-20px.svg",
      "24": "./svg/collapse-down-24px.svg"
    },
    aliases: ["arrow", "down"],
    tags: []
  },
  CollapseUpIcon: {
    description: "",
    sizes: {
      "20": "./svg/collapse-up-20px.svg",
      "24": "./svg/collapse-up-24px.svg"
    },
    aliases: ["arrow", "up"],
    tags: []
  },
  ConversationsIcon: {
    description: "",
    sizes: {
      "20": "./svg/conversations-20px.svg",
      "24": "./svg/conversations-24px.svg"
    },
    aliases: ["comments"],
    tags: []
  },
  CopyIcon: {
    description: "",
    sizes: {
      "16": "./svg/copy-16px.svg",
      "20": "./svg/copy-20px.svg",
      "24": "./svg/copy-24px.svg"
    },
    aliases: ["duplicate"],
    tags: []
  },
  CozyIcon: {
    description: "More spacious view of elements on a page",
    sizes: {
      "20": "./svg/cozy-20px.svg",
      "24": "./svg/cozy-24px.svg"
    },
    aliases: ["airy", "comfortable"],
    tags: []
  },
  CreditCardIcon: {
    description: "",
    sizes: {
      "20": "./svg/credit-card-20px.svg",
      "24": "./svg/credit-card-24px.svg"
    },
    aliases: ["payment"],
    tags: []
  },
  CsvFileIcon: {
    description: "",
    sizes: {
      "20": "./svg/csv-file-20px.svg",
      "24": "./svg/csv-file-24px.svg"
    },
    aliases: ["file"],
    tags: []
  },
  CurrencyBrazilRealIcon: {
    description: "",
    sizes: {
      "24": "./svg/currency-brazil-real-24px.svg"
    },
    aliases: ["BRL"],
    tags: []
  },
  CurrencyDollarIcon: {
    description: "",
    sizes: {
      "20": "./svg/currency-dollar-20px.svg",
      "24": "./svg/currency-dollar-24px.svg"
    },
    aliases: ["USD", "AUD", "CAD", "NZD", "SGD", "HKD"],
    tags: []
  },
  CurrencyEuroIcon: {
    description: "",
    sizes: {
      "24": "./svg/currency-euro-24px.svg"
    },
    aliases: ["EUR"],
    tags: []
  },
  CurrencyIndianRupeeIcon: {
    description: "",
    sizes: {
      "24": "./svg/currency-indian-rupee-24px.svg"
    },
    aliases: ["INR"],
    tags: []
  },
  CurrencyIsraelShekelIcon: {
    description: "",
    sizes: {
      "24": "./svg/currency-israel-shekel-24px.svg"
    },
    aliases: ["ILS"],
    tags: []
  },
  CurrencyJapaneseYenIcon: {
    description: "",
    sizes: {
      "24": "./svg/currency-japanese-yen-24px.svg"
    },
    aliases: ["JPY"],
    tags: []
  },
  CurrencyDanishKroneIcon: {
    description: "",
    sizes: {
      "24": "./svg/currency-danish-krone-24px.svg"
    },
    aliases: ["DKK"],
    tags: []
  },
  CurrencyNorwegianKroneIcon: {
    description: "",
    sizes: {
      "24": "./svg/currency-norwegian-krone-24px.svg"
    },
    aliases: ["NOK"],
    tags: []
  },
  CurrencySwedishKronaIcon: {
    description: "",
    sizes: {
      "24": "./svg/currency-swedish-krona-24px.svg"
    },
    aliases: ["SEK"],
    tags: []
  },
  CurrencyRussianRubleIcon: {
    description: "",
    sizes: {
      "24": "./svg/currency-russian-ruble-24px.svg"
    },
    aliases: ["RUB"],
    tags: []
  },
  CurrencySouthAfricanRandIcon: {
    description: "",
    sizes: {
      "24": "./svg/currency-south-african-rand-24px.svg"
    },
    aliases: ["ZAR"],
    tags: []
  },
  CurrencySouthKoreanWonIcon: {
    description: "",
    sizes: {
      "24": "./svg/currency-south-korean-won-24px.svg"
    },
    aliases: ["KRW"],
    tags: []
  },
  CurrencySwissFrancIcon: {
    description: "",
    sizes: {
      "24": "./svg/currency-swiss-franc-24px.svg"
    },
    aliases: ["CHF"],
    tags: []
  },
  CurrencyBritishPoundIcon: {
    description: "",
    sizes: {
      "24": "./svg/currency-uk-pound-24px.svg"
    },
    aliases: ["GBP"],
    tags: []
  },
  CurveRightIcon: {
    description: "",
    sizes: {
      "20": "./svg/curve-right-20px.svg",
      "24": "./svg/curve-right-24px.svg"
    },
    aliases: ["arc", "bend", "turn", "arrow"],
    tags: []
  },
  CutIcon: {
    description: "",
    sizes: {
      "20": "./svg/cut-20px.svg",
      "24": "./svg/cut-24px.svg"
    },
    aliases: ["scissors"],
    tags: []
  },
  DashIcon: {
    description: "",
    sizes: {
      "20": "./svg/dash-20px.svg",
      "24": "./svg/dash-24px.svg"
    },
    aliases: ["line", "bar", "emdash"],
    tags: [],
    defaultColor: "ursaColors.gold600"
  },
  DashboardsColorIcon: {
    description: "",
    sizes: {
      "20": "./svg/dashboards-color-20px.svg",
      "24": "./svg/dashboards-color-24px.svg"
    },
    aliases: ["asset", "file"],
    tags: []
  },
  DataMeshIcon: {
    description: "",
    sizes: {
      "20": "./svg/data-mesh-20px.svg",
      "24": "./svg/data-mesh-24px.svg"
    },
    aliases: [],
    tags: []
  },
  DatatableIcon: {
    description: "",
    sizes: {
      "20": "./svg/datatable-20px.svg",
      "24": "./svg/datatable-24px.svg"
    },
    aliases: [],
    tags: []
  },
  DateIcon: {
    description: "",
    sizes: {
      "20": "./svg/date-20px.svg",
      "24": "./svg/date-24px.svg"
    },
    aliases: ["calendar", "day", "month", "year"],
    tags: []
  },
  DecreaseDecimalIcon: {
    description: "",
    sizes: {
      "20": "./svg/decrease-decimal-20px.svg",
      "24": "./svg/decrease-decimal-24px.svg"
    },
    aliases: [],
    tags: []
  },
  DiagonalArrowIcon: {
    description: "",
    sizes: {
      "20": "./svg/diagonal-arrow-20px.svg"
    },
    aliases: ["point", "point up", "point down"]
  },
  DiamondIcon: {
    description: "",
    sizes: {
      "20": "./svg/diamond-20px.svg",
      "24": "./svg/diamond-24px.svg"
    },
    aliases: [""],
    tags: [],
    defaultColor: "ursaColors.neutral500"
  },
  DividerIcon: {
    description: "",
    sizes: {
      "20": "./svg/divider-20px.svg",
      "24": "./svg/divider-24px.svg"
    },
    aliases: ["line"],
    tags: []
  },
  DollarsIcon: {
    description: "",
    sizes: {
      // Note that this 20px icon is intentionally used here. We deprecated this icon, renamed
      // the file to currency-dollar-20px.svg, and re-referenced it here to avoid breaking
      // changes.
      "20": "./svg/currency-dollar-20px.svg",
      "24": "./svg/dollars-24px.svg"
    },
    aliases: ["money"],
    tags: [],
    deprecated: {
      message: "Use CurrencyDollarIcon instead. They are the same icon, and this one is the old icon."
    }
  },
  DotIcon: {
    description: "",
    sizes: {
      "20": "./svg/dot-20px.svg",
      "24": "./svg/dot-24px.svg"
    },
    aliases: ["circle"],
    tags: []
  },
  DoubleChevronLeftIcon: {
    description: "",
    sizes: {
      "20": "./svg/double-chevron-left-20px.svg",
      "24": "./svg/double-chevron-left-24px.svg"
    },
    aliases: ["chevron", "left"],
    tags: []
  },
  DoubleChevronRightIcon: {
    description: "",
    sizes: {
      "20": "./svg/double-chevron-right-20px.svg",
      "24": "./svg/double-chevron-right-24px.svg"
    },
    aliases: ["chevron", "right"],
    tags: []
  },
  DoubleDiamondIcon: {
    description: "",
    sizes: {
      "20": "./svg/double-diamond-20px.svg",
      "24": "./svg/double-diamond-24px.svg"
    },
    aliases: ["black diamond"],
    tags: [],
    defaultColor: "ursaColors.neutral500"
  },
  DownArrowIcon: {
    description: "",
    sizes: {
      "20": "./svg/down-arrow-20px.svg",
      "24": "./svg/down-arrow-24px.svg"
    },
    aliases: ["arrow", "down"],
    tags: [],
    defaultColor: "ursaColors.blue400"
  },
  DownloadIcon: {
    description: "",
    sizes: {
      "20": "./svg/download-20px.svg",
      "24": "./svg/download-24px.svg"
    },
    aliases: ["export", "save"],
    tags: []
  },
  DraftCommentIcon: {
    description: "",
    sizes: {
      "16": "./svg/draft-comment-16px.svg"
    },
    aliases: ["chat", "conversation", "edit"],
    tags: [],
    colorSlots: {
      ["transparent"]: {
        propName: "backgroundColor",
        tsDoc: "The fill color for the message bubble background.",
        defaultColor: "transparent"
      }
    }
  },
  DynamicViewIcon: {
    description: "",
    sizes: {
      "20": "./svg/dynamic-view-20px.svg",
      "24": "./svg/dynamic-view-24px.svg"
    },
    aliases: ["filter", "grid"],
    tags: []
  },
  EditDateIcon: {
    description: "",
    sizes: {
      "16": "./svg/edit-date-16px.svg",
      "20": "./svg/edit-date-20px.svg",
      "24": "./svg/edit-date-24px.svg"
    },
    aliases: ["calendar", "day", "month", "year", "modify"],
    tags: []
  },
  EmailIcon: {
    description: "",
    sizes: {
      "20": "./svg/email-20px.svg",
      "24": "./svg/email-24px.svg"
    },
    aliases: ["mail"],
    tags: []
  },
  EraserIcon: {
    description: "",
    sizes: {
      "20": "./svg/eraser-20px.svg",
      "24": "./svg/eraser-24px.svg"
    },
    aliases: ["delete", "remove"],
    tags: []
  },
  ErrorIcon: {
    description: "",
    sizes: {
      "16": "./svg/error-16px.svg",
      "20": "./svg/error-20px.svg",
      "24": "./svg/error-24px.svg"
    },
    aliases: ["exclamation mark"],
    tags: []
  },
  ExclamationAlertErrorIcon: {
    description: "",
    sizes: {
      "20": "./svg/exclamation-alert-error-20px.svg",
      "24": "./svg/exclamation-alert-error-24px.svg"
    },
    aliases: ["alert", "exclamation", "error", "warning"],
    tags: []
  },
  ExclamationOnDotIcon: {
    description: "",
    sizes: {
      "10": "./svg/exclamation-on-dot-10px.svg",
      "16": "./svg/exclamation-on-dot-16px.svg",
      "20": "./svg/exclamation-on-dot-20px.svg",
      "24": "./svg/exclamation-on-dot-24px.svg"
    },
    aliases: ["alert", "warning", "on hold"],
    tags: [],
    defaultColor: "ursaColors.gold600"
  },
  ExitFullscreenIcon: {
    description: "",
    sizes: {
      "20": "./svg/exit-fullscreen-20px.svg",
      "24": "./svg/exit-fullscreen-24px.svg"
    },
    aliases: ["exit", "minimize"],
    tags: []
  },
  ExpandIcon: {
    description: "",
    sizes: {
      "20": "./svg/expand-20px.svg",
      "24": "./svg/expand-24px.svg"
    },
    aliases: ["maximize"],
    tags: []
  },
  ExpandLeftIcon: {
    description: "",
    sizes: {
      "20": "./svg/expand-left-20px.svg",
      "24": "./svg/expand-left-24px.svg"
    },
    aliases: ["collapse", "expand", "left"],
    tags: []
  },
  ExpandRightIcon: {
    description: "",
    sizes: {
      "20": "./svg/expand-right-20px.svg",
      "24": "./svg/expand-right-24px.svg"
    },
    aliases: ["collapse", "expand", "right"],
    tags: []
  },
  ExpandVerticalIcon: {
    description: "",
    sizes: {
      "20": "./svg/expand-vertical-20px.svg",
      "24": "./svg/expand-vertical-24px.svg"
    },
    aliases: ["expand", "full screen", "maximize"],
    tags: []
  },
  EyeHideIcon: {
    description: "",
    sizes: {
      "20": "./svg/eye-hide-20px.svg",
      "24": "./svg/eye-hide-24px.svg"
    },
    aliases: ["hide", "invisible", "mask", "password"],
    tags: []
  },
  EyeShowIcon: {
    description: "",
    sizes: {
      "20": "./svg/eye-show-20px.svg",
      "24": "./svg/eye-show-24px.svg"
    },
    aliases: ["show", "visible", "view"],
    tags: []
  },
  FastForwardIcon: {
    description: "",
    sizes: {
      "20": "./svg/fast-forward-20px.svg",
      "24": "./svg/fast-forward-24px.svg"
    },
    aliases: [],
    tags: [],
    defaultColor: "ursaColors.neutral500"
  },
  FeedbackIcon: {
    description: "",
    sizes: {
      "20": "./svg/feedback-20px.svg",
      "24": "./svg/feedback-24px.svg"
    },
    aliases: [],
    tags: []
  },
  FilterIcon: {
    description: "",
    sizes: {
      "16": "./svg/filter-16px.svg",
      "20": "./svg/filter-20px.svg",
      "24": "./svg/filter-24px.svg"
    },
    aliases: ["funnel"],
    tags: []
  },
  FilterOffIcon: {
    description: "",
    sizes: {
      "16": "./svg/filter-off-16px.svg",
      "20": "./svg/filter-off-20px.svg",
      "24": "./svg/filter-off-24px.svg"
    },
    aliases: ["funnel"],
    tags: []
  },
  FlagIcon: {
    description: "",
    sizes: {
      "20": "./svg/flag-20px.svg",
      "24": "./svg/flag-24px.svg"
    },
    aliases: [],
    tags: []
  },
  FlagFilledIcon: {
    description: "",
    sizes: {
      "20": "./svg/flag-filled-20px.svg",
      "24": "./svg/flag-filled-24px.svg"
    },
    aliases: [],
    tags: []
  },
  FolderIcon: {
    description: "",
    sizes: {
      "20": "./svg/folder-20px.svg",
      "24": "./svg/folder-24px.svg"
    },
    aliases: [],
    tags: []
  },
  FolderColorIcon: {
    description: "",
    sizes: {
      "20": "./svg/folder-color-20px.svg",
      "24": "./svg/folder-color-24px.svg"
    },
    aliases: [],
    tags: []
  },
  FormatIcon: {
    description: "Format Icon for New Views Toolbar",
    sizes: {
      "20": "./svg/format-20px.svg",
      "24": "./svg/format-24px.svg"
    },
    aliases: ["edit", "style"],
    tags: []
  },
  FormsIcon: {
    description: "Forms",
    sizes: {
      "20": "./svg/forms-20px.svg",
      "24": "./svg/forms-24px.svg"
    },
    aliases: [],
    tags: []
  },
  FormsColorIcon: {
    description: "Forms",
    sizes: {
      "20": "./svg/forms-color-20px.svg",
      "24": "./svg/forms-color-24px.svg"
    },
    aliases: [],
    tags: []
  },
  FormTitleIcon: {
    description: "",
    sizes: {
      "20": "./svg/form-title-20px.svg",
      "24": "./svg/form-title-24px.svg"
    },
    aliases: ["header", "title"],
    tags: []
  },
  FormulaIcon: {
    description: "",
    sizes: {
      "16": "./svg/formula-16px.svg",
      "20": "./svg/formula-20px.svg",
      "24": "./svg/formula-24px.svg"
    },
    aliases: ["function"],
    tags: []
  },
  FullOverflowIcon: {
    description: "",
    sizes: {
      "20": "./svg/full-overflow-20px.svg",
      "24": "./svg/full-overflow-24px.svg"
    },
    aliases: [],
    tags: []
  },
  FullscreenIcon: {
    description: "",
    sizes: {
      "20": "./svg/fullscreen-20px.svg",
      "24": "./svg/fullscreen-24px.svg"
    },
    aliases: ["maximize"],
    tags: []
  },
  FunctionIcon: {
    description: "",
    sizes: {
      "20": "./svg/function-20px.svg",
      "24": "./svg/function-24px.svg"
    },
    aliases: ["formula"],
    tags: []
  },
  GanttIcon: {
    description: "",
    sizes: {
      "20": "./svg/gantt-20px.svg",
      "24": "./svg/gantt-24px.svg"
    },
    aliases: [],
    tags: [],
    colorSlots: {
      ["transparent"]: {
        propName: "backgroundColor",
        tsDoc: "The fill color for the background.",
        defaultColor: "transparent"
      }
    }
  },
  GoToDateIcon: {
    description: "",
    sizes: {
      "20": "./svg/go-to-date-20px.svg",
      "24": "./svg/go-to-date-24px.svg"
    },
    aliases: [],
    tags: []
  },
  GridIcon: {
    description: "Grid view",
    sizes: {
      "20": "./svg/grid-20px.svg",
      "24": "./svg/grid-24px.svg"
    },
    aliases: [],
    tags: [],
    colorSlots: {
      ["transparent"]: {
        propName: "backgroundColor",
        tsDoc: "The fill color for the background.",
        defaultColor: "transparent"
      }
    }
  },
  GroupIcon: {
    description: "",
    sizes: {
      "20": "./svg/group-20px.svg",
      "24": "./svg/group-24px.svg"
    },
    aliases: ["combine"],
    tags: []
  },
  HandIcon: {
    description: "",
    sizes: {
      "20": "./svg/hand-20px.svg",
      "24": "./svg/hand-24px.svg"
    },
    aliases: ["grab", "drag"],
    tags: []
  },
  HashmarkIcon: {
    description: "",
    sizes: {
      "20": "./svg/hashmark-20px.svg",
      "24": "./svg/hashmark-24px.svg"
    },
    aliases: ["hashtag", "number", "pound"],
    tags: []
  },
  HeaderIcon: {
    description: "",
    sizes: {
      "20": "./svg/header-20px.svg",
      "24": "./svg/header-24px.svg"
    },
    aliases: ["title"],
    tags: []
  },
  HeartFilledIcon: {
    description: "",
    sizes: {
      "20": "./svg/heart-filled-20px.svg",
      "24": "./svg/heart-filled-24px.svg"
    },
    aliases: ["love"],
    tags: [],
    defaultColor: "ursaColors.red500"
  },
  HeartIcon: {
    description: "",
    sizes: {
      "20": "./svg/heart-20px.svg",
      "24": "./svg/heart-24px.svg"
    },
    aliases: ["love"],
    tags: [],
    defaultColor: "ursaColors.neutral300"
  },
  HelpIcon: {
    description: "",
    sizes: {
      "20": "./svg/help-20px.svg",
      "24": "./svg/help-24px.svg"
    },
    aliases: ["question mark", "support"],
    tags: []
  },
  HierarchyIcon: {
    description: "",
    sizes: {
      "20": "./svg/hierarchy-20px.svg",
      "24": "./svg/hierarchy-24px.svg"
    },
    aliases: ["levels", "chart"],
    tags: []
  },
  HighlightChangesIcon: {
    description: "",
    sizes: {
      "20": "./svg/highlight-changes-20px.svg",
      "24": "./svg/highlight-changes-24px.svg"
    },
    aliases: [],
    tags: [],
    colorSlots: {
      [_designTokens.ursaColors.blue500]: {
        tsDoc: "The color of the highlight bar on the bottom.",
        propName: "selectedColor"
      }
    }
  },
  HistoryIcon: {
    description: "",
    sizes: {
      "20": "./svg/history-20px.svg",
      "24": "./svg/history-24px.svg"
    },
    aliases: ["clock", "time", "refresh"],
    tags: []
  },
  HomeIcon: {
    description: "",
    sizes: {
      "20": "./svg/home-20px.svg",
      "24": "./svg/home-24px.svg"
    },
    aliases: ["house"],
    tags: []
  },
  HtmlFileIcon: {
    description: "",
    sizes: {
      "20": "./svg/html-file-20px.svg",
      "24": "./svg/html-file-24px.svg"
    },
    aliases: ["code"],
    tags: []
  },
  ImageIcon: {
    description: "",
    sizes: {
      "20": "./svg/image-20px.svg",
      "24": "./svg/image-24px.svg"
    },
    aliases: ["picture"],
    tags: []
  },
  IncreaseDecimalIcon: {
    description: "",
    sizes: {
      "20": "./svg/increase-decimal-20px.svg",
      "24": "./svg/increase-decimal-24px.svg"
    },
    aliases: [],
    tags: []
  },
  IndentIcon: {
    description: "",
    sizes: {
      "20": "./svg/indent-20px.svg",
      "24": "./svg/indent-24px.svg"
    },
    aliases: ["tab"],
    tags: []
  },
  InfoIcon: {
    description: "",
    sizes: {
      "16": "./svg/info-16px.svg",
      "20": "./svg/info-20px.svg",
      "24": "./svg/info-24px.svg"
    },
    aliases: [],
    tags: []
  },
  InfoFilledIcon: {
    description: "",
    sizes: {
      "10": "./svg/info-filled-10px.svg",
      "16": "./svg/info-filled-16px.svg",
      "20": "./svg/info-filled-20px.svg",
      "24": "./svg/info-filled-24px.svg"
    },
    aliases: [],
    tags: ["information", "banner"]
  },
  InsertCardAboveIcon: {
    description: "",
    sizes: {
      "20": "./svg/insert-card-above-20px.svg",
      "24": "./svg/insert-card-above-24px.svg"
    },
    aliases: ["add"],
    tags: []
  },
  InsertCardBelowIcon: {
    description: "",
    sizes: {
      "20": "./svg/insert-card-below-20px.svg",
      "24": "./svg/insert-card-below-24px.svg"
    },
    aliases: ["add"],
    tags: []
  },
  InsertCardLeftIcon: {
    description: "",
    sizes: {
      "20": "./svg/insert-card-left-20px.svg",
      "24": "./svg/insert-card-left-24px.svg"
    },
    aliases: ["add"],
    tags: []
  },
  InsertCardRightIcon: {
    description: "",
    sizes: {
      "20": "./svg/insert-card-right-20px.svg",
      "24": "./svg/insert-card-right-24px.svg"
    },
    aliases: ["add"],
    tags: []
  },
  InsertColumnLeftIcon: {
    description: "",
    sizes: {
      "20": "./svg/insert-column-left-20px.svg",
      "24": "./svg/insert-column-left-24px.svg"
    },
    aliases: ["add"],
    tags: []
  },
  InsertColumnRightIcon: {
    description: "",
    sizes: {
      "20": "./svg/insert-column-right-20px.svg",
      "24": "./svg/insert-column-right-24px.svg"
    },
    aliases: ["add"],
    tags: []
  },
  InsertRowAboveIcon: {
    description: "",
    sizes: {
      "20": "./svg/insert-row-above-20px.svg",
      "24": "./svg/insert-row-above-24px.svg"
    },
    aliases: ["add"],
    tags: []
  },
  InsertRowBelowIcon: {
    description: "",
    sizes: {
      "20": "./svg/insert-row-below-20px.svg",
      "24": "./svg/insert-row-below-24px.svg"
    },
    aliases: ["add"],
    tags: []
  },
  InsightsIcon: {
    description: "",
    sizes: {
      "20": "./svg/insights-20px.svg",
      "24": "./svg/insights-24px.svg"
    },
    aliases: ["charts", "metrics"],
    tags: []
  },
  ItalicIcon: {
    description: "",
    sizes: {
      "20": "./svg/italic-20px.svg",
      "24": "./svg/italic-24px.svg"
    },
    aliases: ["emphasis"],
    tags: []
  },
  LevelsIcon: {
    description: "",
    sizes: {
      "20": "./svg/levels-20px.svg",
      "24": "./svg/levels-24px.svg"
    },
    aliases: ["hierarchy"],
    tags: []
  },
  LinkIcon: {
    description: "",
    sizes: {
      "20": "./svg/link-20px.svg",
      "24": "./svg/link-24px.svg"
    },
    aliases: ["hyperlink"],
    tags: []
  },
  LockIcon: {
    description: "",
    sizes: {
      "16": "./svg/lock-16px.svg",
      "20": "./svg/lock-20px.svg",
      "24": "./svg/lock-24px.svg"
    },
    aliases: [],
    tags: []
  },
  MagnifyingGlassIcon: {
    description: "",
    sizes: {
      "20": "./svg/magnifying-glass-20px.svg",
      "24": "./svg/magnifying-glass-24px.svg"
    },
    aliases: ["search"],
    tags: []
  },
  MakeSubItemIcon: {
    description: "",
    sizes: {
      "20": "./svg/make-sub-item-20px.svg",
      "24": "./svg/make-sub-item-24px.svg"
    },
    aliases: ["indent"],
    tags: []
  },
  MegaphoneIcon: {
    description: "",
    sizes: {
      "20": "./svg/megaphone-20px.svg",
      "24": "./svg/megaphone-24px.svg"
    },
    aliases: [],
    tags: []
  },
  MentionIcon: {
    description: "",
    sizes: {
      "20": "./svg/mention-20px.svg",
      "24": "./svg/mention-24px.svg"
    },
    aliases: ["chat", "@"],
    tags: []
  },
  MessageIcon: {
    description: "",
    sizes: {
      "16": "./svg/message-16px.svg",
      "20": "./svg/message-20px.svg",
      "24": "./svg/message-24px.svg"
    },
    aliases: ["chat", "comment"],
    tags: [],
    colorSlots: {
      ["transparent"]: {
        propName: "backgroundColor",
        tsDoc: "The fill color for the message bubble background.",
        defaultColor: "transparent"
      }
    }
  },
  MeterOneIcon: {
    description: "",
    sizes: {
      "20": "./svg/meter-one-20px.svg",
      "24": "./svg/meter-one-24px.svg"
    },
    aliases: ["gauge", "measure"],
    tags: [],
    colorSlots: {
      [_designTokens.ursaColors.blue100]: {
        propName: "meterFillColor",
        tsDoc: "The fill color for the filled background.",
        defaultColor: _designTokens.ursaColors.blue100
      }
    }
  },
  MeterTwoIcon: {
    description: "",
    sizes: {
      "20": "./svg/meter-two-20px.svg",
      "24": "./svg/meter-two-24px.svg"
    },
    aliases: ["gauge", "measure"],
    tags: [],
    colorSlots: {
      [_designTokens.ursaColors.blue100]: {
        propName: "meterFillColor",
        tsDoc: "The fill color for the filled background.",
        defaultColor: _designTokens.ursaColors.blue100
      }
    }
  },
  MeterThreeIcon: {
    description: "",
    sizes: {
      "20": "./svg/meter-three-20px.svg",
      "24": "./svg/meter-three-24px.svg"
    },
    aliases: ["gauge", "measure"],
    tags: [],
    colorSlots: {
      [_designTokens.ursaColors.blue100]: {
        propName: "meterFillColor",
        tsDoc: "The fill color for the filled background.",
        defaultColor: _designTokens.ursaColors.blue100
      }
    }
  },
  MetricRulerIcon: {
    description: "",
    sizes: {
      "20": "./svg/metric-ruler-20px.svg",
      "24": "./svg/metric-ruler-24px.svg"
    },
    aliases: ["measure", "scale"],
    tags: []
  },
  MildPainIcon: {
    description: "",
    sizes: {
      "20": "./svg/mild-pain-20px.svg",
      "24": "./svg/mild-pain-24px.svg"
    },
    aliases: ["emoji", "face", "smile"]
  },
  MinusIcon: {
    description: "",
    sizes: {
      "20": "./svg/minus-20px.svg",
      "24": "./svg/minus-24px.svg"
    },
    aliases: ["remove", "subtract"],
    tags: []
  },
  ModeratePainIcon: {
    description: "",
    sizes: {
      "20": "./svg/moderate-pain-20px.svg",
      "24": "./svg/moderate-pain-24px.svg"
    },
    aliases: ["face", "emoji", "apathy"]
  },
  MoreIcon: {
    description: "",
    sizes: {
      "20": "./svg/more-20px.svg",
      "24": "./svg/more-24px.svg"
    },
    aliases: ["kebab", "overflow"],
    tags: []
  },
  MuteIcon: {
    description: "",
    sizes: {
      "20": "./svg/mute-20px.svg",
      "24": "./svg/mute-24px.svg"
    },
    aliases: [],
    tags: []
  },
  NestedSubItemIcon: {
    description: "",
    sizes: {
      "16": "./svg/nested-sub-item-16px.svg",
      "20": "./svg/nested-sub-item-20px.svg",
      "24": "./svg/nested-sub-item-24px.svg"
    },
    aliases: ["indent", "hierarchy"],
    tags: []
  },
  NewWindowIcon: {
    description: "",
    sizes: {
      "20": "./svg/new-window-20px.svg",
      "24": "./svg/new-window-24px.svg"
    },
    aliases: ["tab"],
    tags: []
  },
  NoDateIcon: {
    description: "",
    sizes: {
      "20": "./svg/no-date-20px.svg",
      "24": "./svg/no-date-24px.svg"
    },
    aliases: ["calendar", "day", "month", "year"],
    tags: []
  },
  NoOverflowIcon: {
    description: "",
    sizes: {
      "20": "./svg/no-overflow-20px.svg",
      "24": "./svg/no-overflow-24px.svg"
    },
    aliases: [],
    tags: []
  },
  NoPainIcon: {
    description: "",
    sizes: {
      "20": "./svg/no-pain-20px.svg",
      "24": "./svg/no-pain-24px.svg"
    },
    aliases: ["face", "emoji", "happy", "smile"]
  },
  NoStarIcon: {
    description: "",
    sizes: {
      "20": "./svg/no-star-20px.svg",
      "24": "./svg/no-star-24px.svg"
    },
    aliases: ["rating"],
    tags: []
  },
  OctagonIcon: {
    description: "",
    sizes: {
      "20": "./svg/octagon-20px.svg",
      "24": "./svg/octagon-24px.svg"
    },
    aliases: [],
    defaultColor: "ursaColors.red500"
  },
  OpenBookIcon: {
    description: "",
    sizes: {
      "20": "./svg/open-book-20px.svg",
      "24": "./svg/open-book-24px.svg"
    },
    aliases: ["manual", "read"],
    tags: []
  },
  OutdentIcon: {
    description: "",
    sizes: {
      "20": "./svg/outdent-20px.svg",
      "24": "./svg/outdent-24px.svg"
    },
    aliases: ["tab"],
    tags: []
  },
  PaintRollerIcon: {
    description: "",
    sizes: {
      "20": "./svg/paintroller-20px.svg",
      "24": "./svg/paintroller-24px.svg"
    },
    aliases: ["format"],
    tags: []
  },
  PanelIcon: {
    description: "",
    sizes: {
      "20": "./svg/panel-20px.svg",
      "24": "./svg/panel-24px.svg"
    },
    aliases: ["window", "drawer"],
    tags: []
  },
  PartialOverflowIcon: {
    description: "",
    sizes: {
      "20": "./svg/partial-overflow-20px.svg",
      "24": "./svg/partial-overflow-24px.svg"
    },
    aliases: [],
    tags: []
  },
  PartlySunnyIcon: {
    description: "",
    sizes: {
      "20": "./svg/partly-sunny-20px.svg",
      "24": "./svg/partly-sunny-24px.svg"
    },
    aliases: ["sunshine", "weather", "cloud"]
  },
  PasteIcon: {
    description: "",
    sizes: {
      "20": "./svg/paste-20px.svg",
      "24": "./svg/paste-24px.svg"
    },
    aliases: ["add", "insert"],
    tags: []
  },
  PauseIcon: {
    description: "",
    sizes: {
      "20": "./svg/pause-20px.svg",
      "24": "./svg/pause-24px.svg"
    },
    aliases: ["parallel lines"],
    tags: [],
    defaultColor: "ursaColors.neutral500"
  },
  PdfFileIcon: {
    description: "",
    sizes: {
      "20": "./svg/pdf-file-20px.svg",
      "24": "./svg/pdf-file-24px.svg"
    },
    aliases: ["document"],
    tags: []
  },
  PencilIcon: {
    description: "",
    sizes: {
      "20": "./svg/pencil-20px.svg",
      "24": "./svg/pencil-24px.svg"
    },
    aliases: ["edit", "write"],
    tags: []
  },
  PercentageIcon: {
    description: "",
    sizes: {
      "20": "./svg/percentage-20px.svg",
      "24": "./svg/percentage-24px.svg"
    },
    aliases: [],
    tags: []
  },
  PlayIcon: {
    description: "",
    sizes: {
      "20": "./svg/play-20px.svg",
      "24": "./svg/play-24px.svg"
    },
    aliases: [],
    tags: [],
    defaultColor: "ursaColors.neutral500"
  },
  PlusIcon: {
    description: "",
    sizes: {
      "20": "./svg/plus-20px.svg",
      "24": "./svg/plus-24px.svg"
    },
    aliases: ["add", "insert"],
    tags: []
  },
  PrintIcon: {
    description: "",
    sizes: {
      "20": "./svg/print-20px.svg",
      "24": "./svg/print-24px.svg"
    },
    aliases: [],
    tags: []
  },
  PromoteSubItemIcon: {
    description: "",
    sizes: {
      "20": "./svg/promote-sub-item-20px.svg",
      "24": "./svg/promote-sub-item-24px.svg"
    },
    aliases: ["indent"],
    tags: []
  },
  ProofBoxDashedIcon: {
    description: "",
    sizes: {
      "20": "./svg/proof-box-dashed-20px.svg",
      "24": "./svg/proof-box-dashed-24px.svg"
    },
    aliases: ["iterate", "approve", "orbit"],
    tags: []
  },
  ProofBoxSolidIcon: {
    description: "",
    sizes: {
      "20": "./svg/proof-box-solid-20px.svg",
      "24": "./svg/proof-box-solid-24px.svg"
    },
    aliases: ["iterate", "approve", "orbit"],
    tags: []
  },
  ProofCircleDashedIcon: {
    description: "",
    sizes: {
      "20": "./svg/proof-circle-dashed-20px.svg",
      "24": "./svg/proof-circle-dashed-24px.svg"
    },
    aliases: ["iterate", "approve", "orbit"],
    tags: []
  },
  ProofCircleSolidIcon: {
    description: "",
    sizes: {
      "20": "./svg/proof-circle-solid-20px.svg",
      "24": "./svg/proof-circle-solid-24px.svg"
    },
    aliases: ["iterate", "approve", "orbit"],
    tags: []
  },
  RainIcon: {
    description: "",
    sizes: {
      "20": "./svg/rain-20px.svg",
      "24": "./svg/rain-24px.svg"
    },
    aliases: ["cloud", "weather"]
  },
  ReceiptIcon: {
    description: "",
    sizes: {
      "20": "./svg/receipt-20px.svg",
      "24": "./svg/receipt-24px.svg"
    },
    aliases: ["invoice"],
    tags: []
  },
  RedoIcon: {
    description: "",
    sizes: {
      "20": "./svg/redo-20px.svg",
      "24": "./svg/redo-24px.svg"
    },
    aliases: [],
    tags: []
  },
  RemoveIcon: {
    description: "",
    sizes: {
      "20": "./svg/remove-20px.svg",
      "24": "./svg/remove-24px.svg"
    },
    aliases: ["delete", "minus"],
    tags: []
  },
  ReplyIcon: {
    description: "",
    sizes: {
      "20": "./svg/reply-20px.svg",
      "24": "./svg/reply-24px.svg"
    },
    aliases: ["thread", "comment"],
    tags: []
  },
  ReportsColorIcon: {
    description: "",
    sizes: {
      "20": "./svg/reports-color-20px.svg",
      "24": "./svg/reports-color-24px.svg"
    },
    aliases: ["asset", "file"],
    tags: []
  },
  RequestsIcon: {
    description: "",
    sizes: {
      "20": "./svg/requests-20px.svg",
      "24": "./svg/requests-24px.svg"
    },
    aliases: ["approve", "update"],
    tags: []
  },
  ResourceManagementIcon: {
    description: "",
    sizes: {
      "20": "./svg/resource-management-20px.svg",
      "24": "./svg/resource-management-24px.svg"
    },
    aliases: [],
    tags: []
  },
  RetryIcon: {
    description: "",
    sizes: {
      "20": "./svg/retry-20px.svg",
      "24": "./svg/retry-24px.svg"
    },
    aliases: ["refresh"],
    tags: []
  },
  RewindIcon: {
    description: "",
    sizes: {
      "20": "./svg/rewind-20px.svg",
      "24": "./svg/rewind-24px.svg"
    },
    aliases: [],
    tags: [],
    defaultColor: "ursaColors.neutral500"
  },
  RotateFileIcon: {
    description: "",
    sizes: {
      "20": "./svg/rotate-file-20px.svg",
      "24": "./svg/rotate-file-24px.svg"
    },
    aliases: [],
    tags: []
  },
  RowIcon: {
    description: "",
    sizes: {
      "20": "./svg/row-20px.svg",
      "24": "./svg/row-24px.svg"
    },
    aliases: ["table"],
    tags: []
  },
  RowResizeIcon: {
    description: "",
    sizes: {
      "20": "./svg/row-resize-20px.svg",
      "24": "./svg/row-resize-24px.svg"
    },
    aliases: [],
    tags: []
  },
  SendIcon: {
    description: "",
    sizes: {
      "20": "./svg/send-20px.svg",
      "24": "./svg/send-24px.svg"
    },
    aliases: ["paper airplane", "mail"],
    tags: []
  },
  SeparateChildCardIcon: {
    description: "",
    sizes: {
      "20": "./svg/separate-child-card-20px.svg",
      "24": "./svg/separate-child-card-24px.svg"
    },
    aliases: ["individual", "distinct"],
    tags: []
  },
  SettingsIcon: {
    description: "",
    sizes: {
      "20": "./svg/settings-20px.svg",
      "24": "./svg/settings-24px.svg"
    },
    aliases: ["gear", "preferences"],
    tags: []
  },
  SeverePainIcon: {
    description: "",
    sizes: {
      "20": "./svg/severe-pain-20px.svg",
      "24": "./svg/severe-pain-24px.svg"
    },
    aliases: ["face", "emoji", "unhappy"],
    defaultColor: "ursaColors.gold600"
  },
  SheetIcon: {
    description: "Sheet",
    sizes: {
      "20": "./svg/sheet-20px.svg",
      "24": "./svg/sheet-24px.svg"
    },
    aliases: ["asset", "file"],
    tags: []
  },
  SheetColorIcon: {
    description: "Sheet",
    sizes: {
      "20": "./svg/sheet-color-20px.svg",
      "24": "./svg/sheet-color-24px.svg"
    },
    aliases: ["asset", "file"],
    tags: [],
    defaultColor: "ursaColors.blue500"
  },
  SheetSummaryIcon: {
    description: "",
    sizes: {
      "20": "./svg/sheet-summary-20px.svg",
      "24": "./svg/sheet-summary-24px.svg"
    },
    aliases: [],
    tags: []
  },
  SmileyFaceIcon: {
    description: "",
    sizes: {
      "20": "./svg/smiley-face-20px.svg",
      "24": "./svg/smiley-face-24px.svg"
    },
    aliases: ["emoji", "face", "happy"],
    tags: []
  },
  SortIcon: {
    description: "Rearranging results",
    sizes: {
      "20": "./svg/sort-20px.svg",
      "24": "./svg/sort-24px.svg"
    },
    aliases: [],
    tags: []
  },
  SquareIcon: {
    description: "",
    sizes: {
      "20": "./svg/square-20px.svg",
      "24": "./svg/square-24px.svg"
    },
    aliases: ["stop", "box"],
    tags: [],
    defaultColor: "ursaColors.neutral500"
  },
  StarFilledIcon: {
    description: "",
    sizes: {
      "20": "./svg/star-filled-20px.svg",
      "24": "./svg/star-filled-24px.svg"
    },
    aliases: ["favorite"],
    tags: []
  },
  StarOutlineIcon: {
    description: "",
    sizes: {
      "20": "./svg/star-outline-20px.svg",
      "24": "./svg/star-outline-24px.svg"
    },
    aliases: ["favorite"],
    tags: []
  },
  StatusIcon: {
    description: "",
    sizes: {
      "20": "./svg/status-20px.svg",
      "24": "./svg/status-24px.svg"
    },
    aliases: ["save"],
    tags: []
  },
  StatusIssueServiceDownIcon: {
    description: "",
    sizes: {
      "20": "./svg/status-issue-service-down-20px.svg",
      "24": "./svg/status-issue-service-down-24px.svg"
    },
    aliases: ["save"],
    tags: []
  },
  StatusUpdatedIcon: {
    description: "",
    sizes: {
      "20": "./svg/status-updated-20px.svg",
      "24": "./svg/status-updated-24px.svg"
    },
    aliases: ["save"],
    tags: []
  },
  StatusUpdatingIcon: {
    description: "",
    sizes: {
      "20": "./svg/status-updating-20px.svg",
      "24": "./svg/status-updating-24px.svg"
    },
    aliases: ["save"],
    tags: []
  },
  StepBackwardIcon: {
    description: "",
    sizes: {
      "20": "./svg/step-backward-20px.svg",
      "24": "./svg/step-backward-24px.svg"
    },
    aliases: ["previous", "rewind"],
    tags: []
  },
  StepForwardIcon: {
    description: "",
    sizes: {
      "20": "./svg/step-forward-20px.svg",
      "24": "./svg/step-forward-24px.svg"
    },
    aliases: ["next"],
    tags: []
  },
  StormIcon: {
    description: "",
    sizes: {
      "20": "./svg/storm-20px.svg",
      "24": "./svg/storm-24px.svg"
    },
    aliases: ["cloud", "weather", "lightning"]
  },
  StrikeoutIcon: {
    description: "",
    sizes: {
      "20": "./svg/strikeout-20px.svg",
      "24": "./svg/strikeout-24px.svg"
    },
    aliases: ["strikethrough"],
    tags: []
  },
  StyleIcon: {
    description: "",
    sizes: {
      "20": "./svg/style-20px.svg",
      "24": "./svg/style-24px.svg"
    },
    aliases: ["paint bucket"],
    tags: []
  },
  SubtaskIcon: {
    description: "",
    sizes: {
      "20": "./svg/subtask-20px.svg",
      "24": "./svg/subtask-24px.svg"
    },
    aliases: [],
    tags: []
  },
  SuccessFilledIcon: {
    description: "",
    sizes: {
      "20": "./svg/success-filled-20px.svg",
      "24": "./svg/success-filled-24px.svg"
    },
    aliases: ["checkmark", "tick"],
    tags: ["success", "banner"]
  },
  SunnyIcon: {
    description: "",
    sizes: {
      "20": "./svg/sunny-20px.svg",
      "24": "./svg/sunny-24px.svg"
    },
    aliases: ["sunshine", "weather"]
  },
  SvgFileIcon: {
    description: "",
    sizes: {
      "20": "./svg/svg-file-20px.svg",
      "24": "./svg/svg-file-24px.svg"
    },
    aliases: ["code"],
    tags: []
  },
  SymbolsIcon: {
    description: "",
    sizes: {
      "20": "./svg/symbols-20px.svg",
      "24": "./svg/symbols-24px.svg"
    },
    aliases: ["shapes", "circle", "square"],
    tags: []
  },
  SyncErrorIcon: {
    description: "",
    sizes: {
      "16": "./svg/sync-error-16px.svg",
      "20": "./svg/sync-error-20px.svg",
      "24": "./svg/sync-error-24px.svg"
    },
    aliases: ["refresh"],
    tags: [],
    colorSlots: {
      ["transparent"]: {
        propName: "backgroundColor",
        tsDoc: "The fill color for the circle background.",
        defaultColor: "transparent"
      }
    }
  },
  SyncSuccessIcon: {
    description: "",
    sizes: {
      "16": "./svg/sync-success-16px.svg",
      "20": "./svg/sync-success-20px.svg",
      "24": "./svg/sync-success-24px.svg"
    },
    aliases: ["refresh"],
    tags: [],
    colorSlots: {
      ["transparent"]: {
        propName: "backgroundColor",
        tsDoc: "The fill color for the circle background.",
        defaultColor: "transparent"
      }
    }
  },
  SyncWarningIcon: {
    description: "",
    sizes: {
      "16": "./svg/sync-warning-16px.svg",
      "20": "./svg/sync-warning-20px.svg",
      "24": "./svg/sync-warning-24px.svg"
    },
    aliases: ["refresh"],
    tags: [],
    colorSlots: {
      ["transparent"]: {
        propName: "backgroundColor",
        tsDoc: "The fill color for the circle background.",
        defaultColor: "transparent"
      }
    }
  },
  TagIcon: {
    description: "",
    sizes: {
      "20": "./svg/tag-20px.svg",
      "24": "./svg/tag-24px.svg"
    },
    aliases: ["label"],
    tags: []
  },
  TaskListIcon: {
    description: "",
    sizes: {
      "20": "./svg/task-list-20px.svg",
      "24": "./svg/task-list-24px.svg"
    },
    aliases: ["checklist"],
    tags: [],
    colorSlots: {
      ["transparent"]: {
        propName: "backgroundColor",
        tsDoc: "The fill color for the background.",
        defaultColor: "transparent"
      }
    }
  },
  TemplateIcon: {
    description: "",
    sizes: {
      "20": "./svg/template-20px.svg",
      "24": "./svg/template-24px.svg"
    },
    aliases: [],
    tags: []
  },
  TextIcon: {
    description: "",
    sizes: {
      "20": "./svg/text-20px.svg",
      "24": "./svg/text-24px.svg"
    },
    aliases: ["A"],
    tags: []
  },
  TextAlignmentIcon: {
    description: "",
    sizes: {
      "20": "./svg/text-alignment-20px.svg",
      "24": "./svg/text-alignment-24px.svg"
    },
    aliases: ["left"],
    tags: []
  },
  TextAlignmentBottomIcon: {
    description: "",
    sizes: {
      "24": "./svg/text-alignment-bottom-24px.svg"
    },
    aliases: [],
    tags: []
  },
  TextAlignmentCenterIcon: {
    description: "",
    sizes: {
      "24": "./svg/text-alignment-center-24px.svg"
    },
    aliases: [],
    tags: []
  },
  TextAlignmentMiddleIcon: {
    description: "",
    sizes: {
      "24": "./svg/text-alignment-middle-24px.svg"
    },
    aliases: [],
    tags: []
  },
  TextAlignmentRightIcon: {
    description: "",
    sizes: {
      "24": "./svg/text-alignment-right-24px.svg"
    },
    aliases: [],
    tags: []
  },
  TextAlignmentTopIcon: {
    description: "",
    sizes: {
      "24": "./svg/text-alignment-top-24px.svg"
    },
    aliases: [],
    tags: []
  },
  TextColorIcon: {
    description: "",
    sizes: {
      "20": "./svg/text-color-20px.svg",
      "24": "./svg/text-color-24px.svg"
    },
    aliases: ["color", "text"],
    tags: []
  },
  TextColorWithSelectionIcon: {
    description: "",
    sizes: {
      "20": "./svg/text-color-with-selection-20px.svg",
      "24": "./svg/text-color-with-selection-24px.svg"
    },
    aliases: ["color", "text"],
    tags: [],
    colorSlots: {
      [_designTokens.ursaColors.blue500]: {
        propName: "selectedColor",
        tsDoc: "The color of the highlight bar at the bottom."
      }
    }
  },
  TextWrapIcon: {
    description: "",
    sizes: {
      "20": "./svg/text-wrap-20px.svg",
      "24": "./svg/text-wrap-24px.svg"
    },
    aliases: ["wrap"],
    tags: []
  },
  ThickDiagonalArrowIcon: {
    description: "",
    sizes: {
      "20": "./svg/thick-diagonal-arrow-20px.svg",
      "24": "./svg/thick-diagonal-arrow-24px.svg"
    },
    aliases: ["point", "direct"],
    defaultColor: "ursaColors.neutral800"
  },
  ThickRightArrowIcon: {
    description: "",
    sizes: {
      "20": "./svg/thick-right-arrow-20px.svg",
      "24": "./svg/thick-right-arrow-24px.svg"
    },
    aliases: ["point", "direct"],
    defaultColor: "ursaColors.neutral800"
  },
  ThousandsIcon: {
    description: "",
    sizes: {
      "20": "./svg/thousands-20px.svg",
      "24": "./svg/thousands-24px.svg"
    },
    aliases: [],
    tags: []
  },
  TimelineIcon: {
    description: "",
    sizes: {
      "20": "./svg/timeline-20px.svg",
      "24": "./svg/timeline-24px.svg"
    },
    aliases: ["roadmap"],
    tags: [],
    colorSlots: {
      ["transparent"]: {
        propName: "backgroundColor",
        tsDoc: "The fill color for the circle background.",
        defaultColor: "transparent"
      }
    }
  },
  TimescaleIcon: {
    description: "",
    sizes: {
      "20": "./svg/timescale-20px.svg",
      "24": "./svg/timescale-24px.svg"
    },
    aliases: [],
    tags: []
  },
  TrashcanIcon: {
    description: "",
    sizes: {
      "20": "./svg/trashcan-20px.svg",
      "24": "./svg/trashcan-24px.svg"
    },
    aliases: ["delete", "remove"],
    tags: []
  },
  TriangleIcon: {
    description: "Used in the green-up and red-down custom icon, as well as the Play icon.",
    sizes: {
      "20": "./svg/triangle-20px.svg",
      "24": "./svg/triangle-24px.svg"
    },
    aliases: ["up", "down", "play"],
    tags: []
  },
  TriangleRoundedIcon: {
    description: "",
    sizes: {
      "20": "./svg/triangle-rounded-20px.svg",
      "24": "./svg/triangle-rounded-24px.svg"
    },
    aliases: [],
    defaultColor: "ursaColors.gold600"
  },
  TriggerIcon: {
    description: "",
    sizes: {
      "20": "./svg/trigger-20px.svg",
      "24": "./svg/trigger-24px.svg"
    },
    aliases: ["lightning", "bolt"],
    tags: []
  },
  UnderlineIcon: {
    description: "",
    sizes: {
      "20": "./svg/underline-20px.svg",
      "24": "./svg/underline-24px.svg"
    },
    aliases: [],
    tags: []
  },
  UndoIcon: {
    description: "",
    sizes: {
      "20": "./svg/undo-20px.svg",
      "24": "./svg/undo-24px.svg"
    },
    aliases: [],
    tags: []
  },
  UnmuteIcon: {
    description: "",
    sizes: {
      "20": "./svg/unmute-20px.svg",
      "24": "./svg/unmute-24px.svg"
    },
    aliases: [],
    tags: []
  },
  UntagIcon: {
    description: "",
    sizes: {
      "20": "./svg/untag-20px.svg",
      "24": "./svg/untag-24px.svg"
    },
    aliases: ["remove", "label"],
    tags: []
  },
  UploadIcon: {
    description: "",
    sizes: {
      "20": "./svg/upload-20px.svg",
      "24": "./svg/upload-24px.svg"
    },
    aliases: ["import"],
    tags: []
  },
  UploadDatatableIcon: {
    description: "",
    sizes: {
      "20": "./svg/upload-datatable-20px.svg",
      "24": "./svg/upload-datatable-24px.svg"
    },
    aliases: [],
    tags: []
  },
  UserIcon: {
    description: "",
    sizes: {
      "14": "./svg/user-14px.svg",
      "16": "./svg/user-16px.svg",
      "20": "./svg/user-20px.svg",
      "24": "./svg/user-24px.svg"
    },
    aliases: ["avatar", "person", "human"],
    tags: []
  },
  UserGroupIcon: {
    description: "",
    sizes: {
      "14": "./svg/user-group-14px.svg",
      "16": "./svg/user-group-16px.svg",
      "20": "./svg/user-group-20px.svg",
      "24": "./svg/user-group-24px.svg"
    },
    aliases: ["avatar", "person", "human"],
    tags: []
  },
  UserWithCheckmarkIcon: {
    description: "",
    sizes: {
      "20": "./svg/user-with-checkmark-20px.svg",
      "24": "./svg/user-with-checkmark-24px.svg"
    },
    aliases: ["avatar", "person", "human"],
    tags: []
  },
  UserWithPencil: {
    description: "",
    sizes: {
      "20": "./svg/user-with-pencil-20px.svg",
      "24": "./svg/user-with-pencil-24px.svg"
    },
    aliases: ["edit", "profile"],
    tags: []
  },
  UserWithPlusIcon: {
    description: "",
    sizes: {
      "20": "./svg/user-with-plus-20px.svg",
      "24": "./svg/user-with-plus-24px.svg"
    },
    aliases: ["person", "profile", "team"],
    tags: []
  },
  VersionCurrentIcon: {
    description: "",
    sizes: {
      "20": "./svg/version-current-20px.svg",
      "24": "./svg/version-current-24px.svg"
    },
    aliases: ["stack"],
    tags: []
  },
  VersionCompareIcon: {
    description: "",
    sizes: {
      "20": "./svg/version-compare-20px.svg",
      "24": "./svg/version-compare-24px.svg"
    },
    aliases: ["stack"],
    tags: []
  },
  VersionPreviousIcon: {
    description: "",
    sizes: {
      "20": "./svg/version-previous-20px.svg",
      "24": "./svg/version-previous-24px.svg"
    },
    aliases: ["stack"],
    tags: []
  },
  VerySeverePainIcon: {
    description: "",
    sizes: {
      "20": "./svg/very-severe-pain-20px.svg",
      "24": "./svg/very-severe-pain-24px.svg"
    },
    aliases: ["face", "emoji", "unhappy"]
  },
  VideoIcon: {
    description: "",
    sizes: {
      "20": "./svg/video-20px.svg",
      "24": "./svg/video-24px.svg"
    },
    aliases: ["film", "camera"],
    tags: []
  },
  VideoFileIcon: {
    description: "",
    sizes: {
      "20": "./svg/video-file-20px.svg",
      "24": "./svg/video-file-24px.svg"
    },
    aliases: ["document"],
    tags: []
  },
  WarningFilledIcon: {
    description: "",
    sizes: {
      "16": "./svg/warning-filled-16px.svg",
      "20": "./svg/warning-filled-20px.svg",
      "24": "./svg/warning-filled-24px.svg"
    },
    aliases: ["alert", "exclamation", "hazard"],
    tags: ["warning", "banner"]
  },
  WebFileIcon: {
    description: "",
    sizes: {
      "20": "./svg/web-file-20px.svg",
      "24": "./svg/web-file-24px.svg"
    },
    aliases: ["asset", "file"],
    tags: []
  },
  WorkAppIcon: {
    description: "",
    sizes: {
      "20": "./svg/workapp-20px.svg",
      "24": "./svg/workapp-24px.svg"
    },
    aliases: [],
    tags: []
  },
  WorkAppColorIcon: {
    description: "",
    sizes: {
      "20": "./svg/workapp-color-20px.svg",
      "24": "./svg/workapp-color-24px.svg"
    },
    aliases: [],
    tags: []
  },
  WorkAppFolderIcon: {
    description: "",
    sizes: {
      "20": "./svg/workapp-folder-20px.svg",
      "24": "./svg/workapp-folder-24px.svg"
    },
    aliases: [],
    tags: []
  },
  WorkAppFolderColorIcon: {
    description: "",
    sizes: {
      "20": "./svg/workapp-folder-color-20px.svg",
      "24": "./svg/workapp-folder-color-24px.svg"
    },
    aliases: [],
    tags: []
  },
  WorkflowAutomationsIcon: {
    description: "",
    sizes: {
      "20": "./svg/workflow-automations-20px.svg",
      "24": "./svg/workflow-automations-24px.svg"
    },
    aliases: [],
    tags: []
  },
  WorkspacesIcon: {
    description: "",
    sizes: {
      "20": "./svg/workspaces-20px.svg",
      "24": "./svg/workspaces-24px.svg"
    },
    aliases: [],
    tags: []
  },
  WorkspacesColorIcon: {
    description: "",
    sizes: {
      "20": "./svg/workspaces-color-20px.svg",
      "24": "./svg/workspaces-color-24px.svg"
    },
    aliases: [],
    tags: []
  },
  WorstPainPossibleIcon: {
    description: "",
    sizes: {
      "20": "./svg/worst-pain-possible-20px.svg",
      "24": "./svg/worst-pain-possible-24px.svg"
    },
    aliases: ["face", "emoji", "unhappy", "angry"]
  },
  XOnDotIcon: {
    description: "",
    sizes: {
      "20": "./svg/x-on-dot-20px.svg"
    },
    aliases: ["forbidden", "no", "error"],
    tags: [],
    defaultColor: "ursaColors.red500"
  },
  ZipFileIcon: {
    description: "",
    sizes: {
      "20": "./svg/zip-file-20px.svg",
      "24": "./svg/zip-file-24px.svg"
    },
    aliases: ["document"],
    tags: []
  },
  ZoomInIcon: {
    description: "",
    sizes: {
      "20": "./svg/zoom-in-20px.svg",
      "24": "./svg/zoom-in-24px.svg"
    },
    aliases: ["add", "plus"],
    tags: []
  },
  ZoomInMagnifyingGlassIcon: {
    description: "",
    sizes: {
      "20": "./svg/zoom-in-magnifying-glass-20px.svg",
      "24": "./svg/zoom-in-magnifying-glass-24px.svg"
    },
    aliases: ["zoom"],
    tags: []
  },
  ZoomOutIcon: {
    description: "",
    sizes: {
      "20": "./svg/zoom-out-20px.svg",
      "24": "./svg/zoom-out-24px.svg"
    },
    aliases: ["remove", "subtract"],
    tags: []
  },
  ZoomOutMagnifyingGlassIcon: {
    description: "",
    sizes: {
      "20": "./svg/zoom-out-magnifying-glass-20px.svg",
      "24": "./svg/zoom-out-magnifying-glass-24px.svg"
    },
    aliases: ["zoom"],
    tags: []
  }
};
exports.iconMeta = iconMeta;
//# sourceMappingURL=iconMeta.js.map